'use strict'

export const REQUEST_LIST_SHIPMENTS = 'REQUEST_LIST_SHIPMENTS'
export const REQUEST_LIST_SHIPMENTS_SUCCESS = 'REQUEST_LIST_SHIPMENTS_SUCCESS'
export const REQUEST_LIST_SHIPMENTS_ERROR = 'REQUEST_LIST_SHIPMENTS_ERROR'

export const REQUEST_CREATE_SHIPMENT = 'REQUEST_CREATE_SHIPMENT'
export const REQUEST_CREATE_SHIPMENT_SUCCESS =
  'REQUEST_CREATE_SHIPMENT_SUCCESS'
export const REQUEST_CREATE_SHIPMENT_ERROR = 'REQUEST_CREATE_SHIPMENT_ERROR'

export const REQUEST_UPDATE_SHIPMENT = 'REQUEST_UPDATE_SHIPMENT'
export const REQUEST_UPDATE_SHIPMENT_SUCCESS =
  'REQUEST_UPDATE_SHIPMENT_SUCCESS'
export const REQUEST_UPDATE_SHIPMENT_ERROR = 'REQUEST_UPDATE_SHIPMENT_ERROR'

export const REQUEST_DELETE_SHIPMENT = 'REQUEST_DELETE_SHIPMENT'
export const REQUEST_DELETE_SHIPMENT_SUCCESS =
  'REQUEST_DELETE_SHIPMENT_SUCCESS'
export const REQUEST_DELETE_SHIPMENT_ERROR = 'REQUEST_DELETE_SHIPMENT_ERROR'

export const REQUEST_GET_SHIPMENT = 'REQUEST_GET_SHIPMENT'
export const REQUEST_GET_SHIPMENT_SUCCESS = 'REQUEST_GET_SHIPMENT_SUCCESS'
export const REQUEST_GET_SHIPMENT_ERROR = 'REQUEST_GET_SHIPMENT_ERROR'

export const TOGGLE_SHIPMENTS2 = 'TOGGLE_SHIPMENTS2'
export const EMPTY_TOGGLE_SHIPMENTS2 = 'EMPTY_TOGGLE_SHIPMENTS2'

export const SET_SHIPMENTS_BY_DATES = 'SET_SHIPMENTS_BY_DATES'

export const SET_SELECTED_SHIPMENT = 'SET_SELECTED_SHIPMENT'
export const UPDATE_SELECTED_SHIPMENT_DROPS = 'UPDATE_SELECTED_SHIPMENT_DROPS'
export const SET_SELECTED_SHIPMENT_SCHEDULE = 'SET_SELECTED_SHIPMENT_SCHEDULE'
export const SET_SELECTED_SHIPMENT_MAP = 'SET_SELECTED_SHIPMENT_SCHEDULE'
export const SET_SELECTED_SHIPMENT_DETAIL_DROPS = 'SET_SELECTED_SHIPMENT_DETAIL_DROPS'
export const REMOVE_SELECTED_SHIPMENT = 'REMOVE_SELECTED_SHIPMENT'
export const SET_SELECTED_SHIPMENT_LABELS = 'SET_SELECTED_SHIPMENT_LABELS'
export const SET_SHIPMENT_IS_FETCHING = 'SET_SHIPMENT_IS_FETCHING'
export const SET_HERE_MAP_OBJECT = 'SET_HERE_MAP_OBJECT'
export const REMOVE_HERE_MAP_OBJECT = 'REMOVE_HERE_MAP_OBJECT'
export const SET_SHIPMENT_SCHEDULE = 'SET_SHIPMENT_SCHEDULE'
export const SET_IS_SHIPMENT_DETAILS = 'SET_IS_SHIPMENT_DETAILS'
export const SET_SHIPMENT_FETCHING_ERROR = 'SET_SHIPMENT_FETCHING_ERROR'

export const SET_LOCATION_PER_SCHEDULE_STOP = 'SET_LOCATION_PER_SCHEDULE_STOP'
export const SET_DROP_PER_SCHEDULE_STOP = 'SET_DROP_PER_SCHEDULE_STOP'
export const SET_SELECTED_SHIPMENT_UNITS_COUNT = 'SET_SELECTED_SHIPMENT_UNITS_COUNT'

export const SET_ASSIGN_DRIVER_LIST = 'SET_ASSIGN_DRIVER_LIST'
export const SET_ASSIGN_VEHICLE_LIST = 'SET_ASSIGN_VEHICLE_LIST'

export const SET_GOODS_VALUE_FETCHING = 'SET_GOODS_VALUE_FETCHING'
export const GOODS_VALUE_UPDATED = 'GOODS_VALUE_UPDATED'

export const SET_RESET_STATE = 'SET_RESET_STATE'
